// extracted by mini-css-extract-plugin
export default {"summary":"MealsSummary_summary__FhRar","supporting":"MealsSummary_supporting__JKbm4","button":"MealsSummary_button__vyGkL"};